import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyleControl = defineStyle({
  width: "20px",
  height: "20px",
  borderRadius: "6px",
  border: "2px solid",
  borderColor: "purple.500",
  bg: "gray.50",
  _checked: {
    bg: "purple.500",
    borderColor: "purple.500",
    color: "white",
    _hover: {
      bg: "purple.500",
      borderColor: "purple.500",
    },
  },
});

const baseStyleIcon = defineStyle({
  w: "8px",
  h: "8px",
});

const baseStyleLabel = defineStyle({
  fontSize: "14px",
  fontWeight: "normal",
});

const baseStyleContainer = defineStyle({
  wordBreak: "break-word",
});

const baseStyle = definePartsStyle({
  control: baseStyleControl,
  icon: baseStyleIcon,
  label: baseStyleLabel,
  container: baseStyleContainer,
});

export const Checkbox = defineMultiStyleConfig({
  baseStyle,
});
